import { statusLabel, t } from '../i18n';
import { Icon } from './icons';
import { StatusBadge, TypeLabel } from './MyFeedback';

import type { SentSummary } from './App';

export function SentView({
  sent,
  onView,
  onMore,
}: {
  sent: SentSummary;
  onView: () => void;
  onMore: () => void;
}) {
  const s = t();
  const { item } = sent;
  return (
    <div class="hfb-sent">
      <span class="hfb-sent-check" aria-hidden="true">
        <Icon name="check" size={26} />
      </span>
      <h2 class="hfb-display">{s.sentTitle}</h2>
      <p class="hfb-muted">{s.sentBody}</p>
      <article class="hfb-card hfb-sent-card">
        <header>
          <span>
            <TypeLabel type={item.type} /> <span class="hfb-muted">· {s.justNow}</span>
          </span>
          <StatusBadge status={item.status} />
        </header>
        <strong>{item.title}</strong>
        <span class="hfb-muted">
          {[sent.screenshots ? s.screenshots(sent.screenshots) : null, sent.path]
            .filter(Boolean)
            .join(' · ')}
        </span>
        <span class="hfb-sr">{statusLabel(item.status.name)}</span>
      </article>
      <div class="hfb-actions">
        <button type="button" class="hfb-btn hfb-btn-primary" onClick={onView}>
          {s.view}
        </button>
        <button type="button" class="hfb-btn hfb-btn-outline" onClick={onMore}>
          {s.sendMore}
        </button>
      </div>
    </div>
  );
}
